const getBaseURL = () => {
    const currentHost = window.location.hostname; 
    if (currentHost.startsWith('www.')) {
        return 'https://www.store.encatalogo.com';
    } else {
        return 'https://store.encatalogo.com';
    }
};

const baseURL = getBaseURL(); 

export default baseURL; 
 
 
{/*   
const baseURL = window.location.origin;

export default baseURL;*/}